// Larguras de referência validadas no Figma (mobile 360px / desktop 1366px).
const MOBILE_WIDTH = 360;
const DESKTOP_WIDTH = 1366;
const VW_PER_PX = (DESKTOP_WIDTH - MOBILE_WIDTH) / 100;

function round(value: number): number {
  return Math.round(value * 100) / 100;
}

/**
 * Gera um valor CSS `clamp()` que interpola linearmente entre `min` (em MOBILE_WIDTH)
 * e `max` (em DESKTOP_WIDTH), em px. Evita calcular o termo do meio à mão.
 */
export function fluidSize(min: number, max: number): string {
  const slope = (max - min) / VW_PER_PX;
  const intercept = min - slope * (MOBILE_WIDTH / 100);
  return `clamp(${min}px, ${round(intercept)}px + ${round(slope)}vw, ${max}px)`;
}
